import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.pad-start.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getDownLoadList, userDownLoad, userDownLoadSearch, delRecord } from '@/views/downLoadCenter/api/api';
export default {
  name: 'downLoadCenterList',
  data: function data() {
    // 创建时间默认最近3个月（含今日）
    var now = new Date();
    var threeMonthsAgo = new Date(now);
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    var formatDate = function formatDate(d) {
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return "".concat(y, "-").concat(m, "-").concat(day);
    };
    return {
      form: {
        create_time: ["".concat(formatDate(threeMonthsAgo), " 00:00:00"), "".concat(formatDate(now), " 23:59:59")],
        // 创建时间
        download_type: '',
        status: '',
        // 状态  0:生成中 1:生成成功 2:生成失败
        is_valid: '1',
        // 是否有效 1有效 2失效
        page: 1
      },
      pages: {},
      dataList: [],
      statusList: [{
        name: "文件生成中",
        id: '0'
      }, {
        name: "文件已生成",
        id: '1'
      }, {
        name: "生成失败",
        id: '2'
      }],
      validList: [{
        name: "有效",
        id: '1'
      }, {
        name: "无效",
        id: '2'
      }],
      download_type_list: []
    };
  },
  created: function created() {
    this.getSearchList();
    this.getList();
  },
  methods: {
    getSearchList: function getSearchList() {
      var _this = this;
      userDownLoadSearch().then(function (res) {
        _this.download_type_list = res.data.download_type;
      });
    },
    // 获取列表
    getList: function getList() {
      var _this2 = this;
      var params = _objectSpread({}, this.form);
      getDownLoadList(params).then(function (res) {
        _this2.dataList = res.data.list;
        _this2.pages = res.pages;
      });
    },
    searchList: function searchList() {
      this.form.page = 1;
      this.getList();
    },
    downLoadFile: function downLoadFile(row) {
      userDownLoad({
        id: row.id
      }).then(function (res) {
        window.open(res.data.path);
      });
    },
    currentChange: function currentChange(current) {
      this.form.page = current;
      this.getList();
    },
    // 重置
    clearForm: function clearForm() {
      this.$refs.form.resetFields();
      this.getList();
    },
    // 删除任务
    remove: function remove(row) {
      var _this3 = this;
      var params = {
        id: row.id
      };
      delRecord(params).then(function (res) {
        _this3.$message.success('删除成功');
        _this3.searchList();
      });
    }
  }
};